import { useEffect } from 'react';

export function useListenDocumentEvent(eventName: string, cb: (ev: any) => void) {
  useEffect(() => {
    const controller = new AbortController();
    document.addEventListener(eventName, cb, { signal: controller.signal });
    return () => controller.abort();
  }, []);
}